export const calcElapsedDateTime = (
  milliseconds: number,
  suffix = ""
): string => {
  const today = new Date();

  const timeDifference = today.getTime() - milliseconds;

  const minuteDifference = Math.floor(timeDifference / 60000);

  if (minuteDifference < 1) {
    return "Less than a minute" + (suffix ? " " + suffix : "");
  } else if (minuteDifference === 1) {
    return "1 minute" + (suffix ? " " + suffix : "");
  } else if (minuteDifference < 60) {
    return `${minuteDifference} minutes` + (suffix ? " " + suffix : "");
  } else if (minuteDifference < 120) {
    return "1 hour" + (suffix ? " " + suffix : "");
  } else if (minuteDifference < 180) {
    return "2 hours" + (suffix ? " " + suffix : "");
  } else if (minuteDifference < 1440) {
    const hours = Math.floor(minuteDifference / 60);
    return `${hours} hours` + (suffix ? " " + suffix : "");
  } else if (minuteDifference < 2880) {
    return "1 day" + (suffix ? " " + suffix : "");
  } else if (minuteDifference < 4320) {
    return "2 days" + (suffix ? " " + suffix : "");
  } else if (minuteDifference < 10080) {
    const days = Math.floor(minuteDifference / 1440);
    return `${days} days` + (suffix ? " " + suffix : "");
  } else if (minuteDifference < 20160) {
    return "1 week" + (suffix ? " " + suffix : "");
  } else if (minuteDifference < 30240) {
    return "2 weeks" + (suffix ? " " + suffix : "");
  } else if (minuteDifference < 40320) {
    return "3 weeks" + (suffix ? " " + suffix : "");
  } else if (minuteDifference < 43800) {
    return "1 month" + (suffix ? " " + suffix : "");
  } else if (minuteDifference < 525601) {
    const months = Math.floor(minuteDifference / 43800);
    return `${months} months` + (suffix ? " " + suffix : "");
  } else {
    const years = Math.floor(minuteDifference / 525601);
    return `${years} years` + (suffix ? " " + suffix : "");
  }
};

export const getTimeZoneAbbreviation = () => {
  const date = new Date();
  const options: Intl.DateTimeFormatOptions = { timeZoneName: "short" };
  const formatter = new Intl.DateTimeFormat("en-US", options);
  const parts = formatter.formatToParts(date);

  // Find the timezone abbreviation part
  const timeZoneAbbr = parts.find((part) => part.type === "timeZoneName");
  return timeZoneAbbr ? timeZoneAbbr.value : "";
};
